import ReviewItem from './ReviewItem';
import { IReview } from '../../../model/reviews';
import { reviews } from '../../../constants/const';

import styles from "./styles.module.scss"

const Reviews = () => {
  return (
    <div className={styles.reviewsWrapper}>
      {reviews.map((review: IReview) => (
        <ReviewItem
          key={review?.id}
          id={review?.id}
          name={review?.name}
          rating={review?.rating}
          date={review?.date}
          review={review?.review}
          patchData={review?.patchData}
        />
      ))}
    </div>
  );
};

export default Reviews;
